// frontend/src/api/template.js
// Funciones API para la gestión de Tipos de Iniciativa y sus Plantillas.
// AHORA CON FUNCIONALIDAD CRUD.

import { request } from './api';

// --- FUNCIONES DE LECTURA ---

export async function getInitiativeTypes(token) {
  return request('/api/templates/initiative-types', 'GET', null, token);
}

export async function getFullTemplateConfiguration(token) {
    return request('/api/templates/configuration', 'GET', null, token);
}

export async function getTemplateDetails(initiativeTypeId, token) {
    return request(`/api/templates/${initiativeTypeId}`, 'GET', null, token);
}

// --- NUEVAS FUNCIONES DE ESCRITURA (CRUD) ---

// Fases de Plantilla
export async function createTemplatePhase(templateId, data, token) {
    return request(`/api/templates/templates/${templateId}/phases`, 'POST', data, token);
}
export async function updateTemplatePhase(phaseId, data, token) {
    return request(`/api/templates/phases/${phaseId}`, 'PUT', data, token);
}
export async function deleteTemplatePhase(phaseId, token) {
    return request(`/api/templates/phases/${phaseId}`, 'DELETE', null, token);
}

// Tareas de Plantilla
export async function createTemplateTask(phaseId, data, token) {
    return request(`/api/templates/phases/${phaseId}/tasks`, 'POST', data, token);
}
export async function updateTemplateTask(taskId, data, token) {
    return request(`/api/templates/tasks/${taskId}`, 'PUT', data, token);
}
export async function deleteTemplateTask(taskId, token) {
    return request(`/api/templates/tasks/${taskId}`, 'DELETE', null, token);
}

// Espacios para Documentos
export async function createDocumentSlot(initiativeTypeId, data, token) {
    return request(`/api/templates/initiative-types/${initiativeTypeId}/documents`, 'POST', data, token);
}
export async function updateDocumentSlot(slotId, data, token) {
    return request(`/api/templates/documents/${slotId}`, 'PUT', data, token);
}
export async function deleteDocumentSlot(slotId, token) {
    return request(`/api/templates/documents/${slotId}`, 'DELETE', null, token);
}
